import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';


  export const getSubscribersByProductAsync = createAsyncThunk('equipmentListPage/getSubscribersByProductAsync', async (data, thunkAPI) => {
        try {
            const result = await ProviderManager.getProviderData('getSubscribersByProduct', [data]);
            return result;
        } catch (error) {
            console.error('getSubscribersByProductAsync error:', error);
            throw error;
        }
    }
  );
